import TiptapBlockquote, {type BlockquoteOptions} from '@tiptap/extension-blockquote';
import classNames from 'classnames';

import appStyles from '../app-post-style.module.css';

export const TimeWebkitBlockquoteExtension = TiptapBlockquote.extend<BlockquoteOptions>({
    renderHTML({HTMLAttributes}) {
        return [
            'blockquote',
            {
                ...HTMLAttributes,
                class: classNames([HTMLAttributes.class, appStyles.blockquote]),
            },
            0,
        ];
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-9': () => {
                if (this.editor.isActive('table')) {
                    return false;
                }
                return this.editor.commands.toggleBlockquote();
            },
        };
    },
}).extend({
    addCommands() {
        return {
            toggleBlockquote: () => ({commands}) => {
                return commands.first([
                    () => commands.mergeAdjacentNodes(this.name),
                    () => commands.toggleWrap(this.name),
                ]);
            },
        };
    },
    addInputRules() {
        return (this.parent?.() ?? []).map((rule) => ({
            ...rule,
            handler: (props) => {
                if (this.editor.isActive('table')) {
                    return;
                }
                return rule.handler(props);
            },
        }));
    },
});
